import { render } from "./RealRegDetail.vue?vue&type=template&id=a14cc446&scoped=true"
import script from "./RealRegDetail.vue?vue&type=script&lang=js"
export * from "./RealRegDetail.vue?vue&type=script&lang=js"

import "./RealRegDetail.vue?vue&type=style&index=0&id=a14cc446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14cc446"]])

export default __exports__